export default "__VITE_ASSET__Dhvzl7Mb__"